module.exports = __webpack_public_path__ + "static/media/04.a51ace21.png";